<div class="input-import">
    <label class="col-form-label" v-if="label" :for="id">{{ label }} <span v-if="required">(*)</span></label>
    <span class="input-group-text" @click="eventShowFile">{{placeholder}}</span>
    <div class="error-text" v-if="errorText">{{errorText}}</div>
    <input type="file" @change="emitChange($event)" class="custom-file-input" id="inputGroupFile01" style="display:none;" ref="inputFile" accept=".xlsx,.xls,.csv" >
</div>